<script lang="ts">
	import type { Device, Lightshow, Scene } from "luxedo-data"
	import { ScheduleController } from "../../../../routes/schedule/ScheduleController"
	import { CalendarIcon } from "luxedo-icons"

	interface Props {
		show: Scene | Lightshow
		device: Device
	}

	let { show, device }: Props = $props()

	function jumpToScheduler() {
		ScheduleController.EventEditor.editEvent(undefined, { show, device })
	}
</script>

<div class="schedule-button-container">
	<button id="schedule-show-btn" class="icon" title="Schedule" onclick={jumpToScheduler}>
		<CalendarIcon />
	</button>
</div>

<style>
	#schedule-show-btn {
		--color-button: var(--color-main);

		outline: 1px solid var(--color-button);
		background-color: var(--color-bg-dark);
		width: 3.5rem;
		height: 3.5rem;
		padding: 1rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		transition: transform 250ms;
	}

	#schedule-show-btn :global(.svg-fill) {
		fill: var(--color-button);
	}

	#schedule-show-btn:hover,
	#schedule-show-btn:focus-visible {
		transform: scale(1.1);
	}
</style>
